import { render, staticRenderFns } from "./QYesNoReadonly.vue?vue&type=template&id=37d352d0&scoped=true"
import script from "./QYesNoReadonly.vue?vue&type=script&lang=js"
export * from "./QYesNoReadonly.vue?vue&type=script&lang=js"
import style0 from "./QYesNoReadonly.vue?vue&type=style&index=0&id=37d352d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d352d0",
  null
  
)

export default component.exports